export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Adres, pod ktorym stoi WIDGET (wlasny kontener i wlasna domena, patrz WIDGET_DOMAIN w .env).
// Pusty w dev — wtedy panel sonduje localhost:4000, jak wczesniej. Na produkcji ustawiany przy
// budowaniu obrazu, bo bez niego panel generowal kod do wklejenia wskazujacy na domene aplikacji,
// gdzie plikow widgetu nie ma (P3.32). Regula w utils/widgetHost.js.
export const WIDGET_BASE = process.env.REACT_APP_WIDGET_HOST || '';
